import React, { useState, useContext, useEffect, memo, useMemo } from "react";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import API from "../../API";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CheckIcon from "@mui/icons-material/Check";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";
import TextField from "@mui/material/TextField";

const SurfReportForm = memo(function SurfReportForm(props) {
    const wavesReports = ["Date/Time", "Surf Quality", "Surf Size", "Wind", "Weather", "Crowd"];
    const [formStep, setFormStep] = useState(0);
    const [rating, setRating] = useState(0);
    const [additionalNotes, setAdditionalNotes] = useState("");
    const [dateTime, setDateTime] = useState(new Date());
    const [labels, setLabels] = useState({});

    const RadioInputs = (props) => {
        const label = props.label;
        const options = props.options;

        const LabelMap = {};

        console.log(labels);
        return (
            <Grid
                container
                sx={{
                    justifyContent: "center",
                    display: "flex",
                    width: "100%",
                    minHeight: "210px",
                }}
                xs={12}
            >
                <Grid sx={{}} item xs={6}>
                    <FormLabel sx={{ fontSize: "30px", color: "white" }} component="legend">
                        {label}
                    </FormLabel>
                </Grid>
                <Grid item xs={6}>
                    <RadioGroup value={labels[label]} aria-label="gender" name="radio-buttons-group" sx={{ color: "white" }}>
                        {options.map((option) => {
                            LabelMap[option.label] = option.value;

                            return (
                                <FormControlLabel
                                    onClick={(e) => {
                                        setLabels((labels) => {
                                            console.log({
                                                [option.label]: option.value,
                                            });
                                            console.log(labels);
                                            return {
                                                ...labels,
                                                [label]: option.value,
                                            };
                                        });
                                        setFormStep((formStep) => formStep + 1);
                                    }}
                                    value={option.value}
                                    control={<Radio />}
                                    label={option.label}
                                />
                            );
                        })}
                    </RadioGroup>
                </Grid>
            </Grid>
        );
    };

    const Crowd = () => {
        const label = "Crowd";
        const options = [
            { value: "whole-island", label: "Whole Island" },
            { value: "crowded", label: "Crowded" },
            { value: "normal", label: "Normal" },
            { value: "few", label: "Few" },
            { value: "solo", label: "Solo" },
        ];

        return <RadioInputs label={label} options={options} />;
    };

    const Weather = () => {
        const label = "Weather";
        const options = [
            { value: "rain", label: "Raining" },
            { value: "overcast", label: "Overcast" },
            { value: "partly-cloudy", label: "Partly Cloudy" },
            { value: "sunny", label: "Sunny" },
        ];

        return <RadioInputs label={label} options={options} />;
    };

    const Wind = () => {
        const label = "Wind";
        const options = [
            { value: "white-caps", label: "White Caps" },
            { value: "onshore", label: "onshore" },
            { value: "sea-breeze", label: "Sea Breeze" },
            { value: "no-wind", label: "No Wind" },
            { value: "off-shore", label: "Off Shore" },
        ];

        return <RadioInputs label={label} options={options} />;
    };

    const SurfQuality = () => {
        const label = "Surf Quality";
        const options = [
            { value: "mushy", label: "Mushy" },
            { value: "bad-direction", label: "Bad Direction" },
            { value: "close-out", label: "Close Out" },
            { value: "clean", label: "Clean" },
            { value: "perfect", label: "Perfect" },
        ];

        return <RadioInputs label={label} options={options} />;
    };

    const SurfSize = () => {
        const label = "Surf Size";
        const options = [
            { value: "flat", label: "Flat" },
            { value: "waist-high", label: "Waist High" },
            { value: "head-high", label: "Head High" },
            { value: "over-head", label: "Over Head" },
            { value: "double-over-head", label: "Double Over Head" },
        ];

        return <RadioInputs label={label} options={options} />;
    };

    const OverallRating = useMemo(() => {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Box
                        sx={
                            {
                                // "& > legend": { mt: 2 },
                            }
                        }
                    >
                        <Typography sx={{ fontSize: "30px", color: "white" }} component="legend">
                            Overall Rating
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Rating
                        size="large"
                        name="overall-rating"
                        value={rating}
                        onChange={(event, newValue) => {
                            setRating(newValue);
                        }}
                        sx={{
                            "& .MuiRating-iconEmpty": {
                                color: "white",
                            },
                        }}
                    />
                    <TextField
                        fullWidth
                        aria-label="empty textarea"
                        placeholder="Additional Notes"
                        required
                        minRows={3}
                        maxRows={6}
                        multiline
                        style={{ width: "100%", color: "white" }}
                        type="text"
                        value={additionalNotes}
                        onChange={(e) => {
                            setAdditionalNotes(e.target.value);
                        }}
                        sx={{
                            "& .MuiInputBase-input": { color: "white" },
                            "& .MuiInputBase-input::placeholder": { color: "rgba(255, 255, 255, 0.7)" },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "white" },
                                "&:hover fieldset": { borderColor: "white" },
                            },
                        }}
                    />
                </Grid>
            </Grid>
        );
    }, [rating, additionalNotes]);

    const [datePickerOpen, setDatePickerOpen] = useState(false);

    const DateTime = useMemo(() => {
        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container sx={{ alignItems: "center" }}>
                    <Grid item xs={9}>
                        <DateTimePicker
                            open={datePickerOpen}
                            onOpen={() => setDatePickerOpen(true)}
                            onClose={() => setDatePickerOpen(false)}
                            renderInput={(props) => (
                                <TextField
                                    {...props}
                                    onClick={() => setDatePickerOpen(true)}
                                    sx={{
                                        "& .MuiInputBase-input": { color: "white" },
                                        "& .MuiInputLabel-root": { color: "white" },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": { borderColor: "white" },
                                            "&:hover fieldset": { borderColor: "white" },
                                        },
                                        "& .MuiIconButton-root": { color: "white" },
                                        "& .MuiSvgIcon-root": { color: "white" },
                                    }}
                                />
                            )}
                            label="DateTimePicker"
                            value={dateTime}
                            onChange={(newValue) => {
                                setDateTime(newValue);
                            }}
                            style={{ width: "100%" }}
                            PopperProps={{
                                placement: "right",
                                sx: {
                                    zIndex: 15000,
                                },
                            }}
                            DialogProps={{
                                sx: {
                                    zIndex: 15000,
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            onClick={() => {
                                setDatePickerOpen(false);
                                setFormStep((step) => step + 1);
                            }}
                            variant="contained"
                            color={"primary"}
                            startIcon={<CheckIcon />}
                        >
                            OK
                        </Button>
                    </Grid>
                </Grid>
            </LocalizationProvider>
        );
    }, [dateTime, datePickerOpen]);

    function getForm() {
        switch (formStep) {
            case 0:
                return DateTime;
                break;

            case 1:
                return <SurfQuality />;
                break;

            case 2:
                return <SurfSize />;
                break;

            case 3:
                return <Wind />;
                break;

            case 4:
                return <Weather />;
                break;

            case 5:
                return <Crowd />;
                break;

            default:
                return OverallRating;
                break;
        }
    }

    const submitReport = async () => {
        const wind = labels["Wind"];
        const crowd = labels["Crowd"];
        const surfQuality = labels["Surf Quality"];
        const weather = labels["Weather"];
        await API.postSurfReport({
            additionalNotes,
            dateTime,
            crowd,
            surfQuality,
            weather,
            wind,
            rating,
            surfSpot: props.info._id,
        });
        props.setAddSurfReport(false);
    };
    return (
        <Grid container>
            <Grid
                item
                container
                xs={12}
                sx={{
                    width: "100%",
                }}
            >
                {formStep < wavesReports.length && (
                    <Grid item xs={12}>
                        <ReportSteps formStep={formStep} steps={wavesReports} />
                    </Grid>
                )}
                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                    item
                    xs={12}
                >
                    <FormControl component="fieldset">{getForm()}</FormControl>
                </Grid>
            </Grid>

            <Grid item container xs={12}>
                <Grid item xs={6}>
                    <Button
                        onClick={() => {
                            props.setAddSurfReport(false);
                        }}
                        variant="contained"
                        color={"secondary"}
                        startIcon={<DoDisturbIcon />}
                    >
                        CANCEL
                    </Button>
                </Grid>

                <Grid item xs={3}>
                    <Button
                        onClick={() =>
                            setFormStep((formStep) => {
                                let back = formStep - 1;
                                if (back < 0) back = 0;
                                return back;
                            })
                        }
                        variant="contained"
                        color={"warning"}
                        startIcon={<ArrowBackIcon />}
                    >
                        Back
                    </Button>
                </Grid>

                {formStep === wavesReports.length && (
                    <Grid item xs={3}>
                        <Button
                            onClick={() => submitReport()}
                            variant="contained"
                            color={"success"}
                            // endIcon={<CheckIcon />}
                        >
                            Submit
                        </Button>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
});

export default SurfReportForm;

const ReportSteps = (props) => {
    const steps = props.steps;
    const formStep = props.formStep;
    return (
        <>
            {/* <div
                role="presentation"
                onClick={(e) => console.log(e.target.innerHTML)}
            >
                <Breadcrumbs aria-label="breadcrumb">
                    {steps.map((step, index) => (
                        <Link
                            color={formStep === index ? "text.primary" : " "}
                            underline="hover"
                            color="inherit"
                            href="#"
                        >
                            {step}
                        </Link>
                    ))}
                </Breadcrumbs>
            </div> */}

            <Stepper
                activeStep={formStep}
                alternativeLabel
                sx={{
                    "& .MuiStepLabel-root": {
                        padding: "0 4px",
                    },
                    "& .MuiStepConnector-root": {
                        flex: "0 0 20px",
                    },
                }}
            >
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel
                            sx={{
                                "& .MuiStepLabel-label": {
                                    color: "white !important",
                                    fontSize: "0.7rem !important",
                                    marginTop: "4px !important",
                                },
                                "& .MuiStepLabel-label.Mui-active": {
                                    color: "white !important",
                                    fontWeight: "bold !important",
                                },
                                "& .MuiStepLabel-label.Mui-completed": {
                                    color: "white !important",
                                },
                                "& .MuiStepIcon-root": {
                                    width: "20px",
                                    height: "20px",
                                },
                            }}
                        >
                            {label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </>
    );
};
